module.exports = __webpack_public_path__ + "static/media/CodigoFonte.b0cc7906.png";